import api from '@/shared/api/client'
import type {
  UserProfile,
  UpdateProfileRequest,
  ChangePasswordRequest,
  ChangePasswordResponse,
  Session,
  NotificationPreference,
  UpdateNotificationPreferencesRequest,
  QueueFilterPreset,
} from '../types'

export const settingsApi = {
  // ── 2.1 Get Profile ──

  getProfile: () =>
    api
      .get<{ data: UserProfile }>('/settings/profile')
      .then((r) => r.data.data),

  // ── 2.2 Update Profile ──

  updateProfile: (body: UpdateProfileRequest) =>
    api
      .patch<{ data: UserProfile }>('/settings/profile', body)
      .then((r) => r.data.data),

  // ── Page-tour status (progressive onboarding; single-key server writes) ──

  putTourStatus: (tourId: string, body: { s: 'offered' | 'started' | 'completed' | 'skipped' | 'dismissed'; v: number }) =>
    api
      .put<{ data: { tourId: string; applied: boolean } }>(`/settings/preferences/tours/${encodeURIComponent(tourId)}`, body)
      .then((r) => r.data.data),

  putTourInvites: (value: 'on' | 'off') =>
    api.put<{ data: { value: 'on' | 'off' } }>('/settings/preferences/tour-invites', { value }).then((r) => r.data.data),

  // ── 2.3 Change Password ──

  changePassword: (body: ChangePasswordRequest) =>
    api
      .post<{ data: ChangePasswordResponse }>('/settings/password', body)
      .then((r) => r.data.data),

  // ── 2.6 List Active Sessions ──

  getSessions: () =>
    api
      .get<{ data: Session[] }>('/settings/sessions')
      .then((r) => r.data.data),

  // ── 2.7 Revoke Session ──

  revokeSession: (sessionId: string) =>
    api.delete(`/settings/sessions/${sessionId}`),

  // ── 2.8 Get Notification Preferences ──

  getNotificationPreferences: () =>
    api
      .get<{ data: NotificationPreference[] }>('/notifications/preferences')
      .then((r) => r.data.data),

  // ── 2.9 Update Notification Preferences ──

  updateNotificationPreferences: (body: UpdateNotificationPreferencesRequest) =>
    api
      .patch<{ data: NotificationPreference[] }>('/notifications/preferences', body)
      .then((r) => r.data.data),

  // ── Queue Filter Presets ──

  listQueueFilterPresets: () =>
    api
      .get<{ data: QueueFilterPreset[] }>('/settings/preferences/queue-filter-presets')
      .then((r) => r.data.data),

  createQueueFilterPreset: (body: { name: string; filters: Record<string, unknown> }) =>
    api
      .post<{ data: QueueFilterPreset }>('/settings/preferences/queue-filter-presets', body)
      .then((r) => r.data.data),

  deleteQueueFilterPreset: (presetId: string) =>
    api
      .delete<{ data: { deleted: true } }>(`/settings/preferences/queue-filter-presets/${presetId}`)
      .then((r) => r.data.data),
}
